export const smoosh = (nestedArray: any[]): any[] =>
  nestedArray.reduce((acc, val) => {
    if (Array.isArray(val)) {
      return acc.concat(smoosh(val))
    }
    return acc.concat(val)
  }, [])
